/**
 * This file defines the schemas for the playlist agent functions.
 * These schemas follow the OpenAI function calling format.
 */

import { ChatCompletionTool } from 'openai/resources';

export const searchAgentTools: ChatCompletionTool[] = [
  {
    type: "function",
    function: {
      name: "searchInternet",
      description: "Search the internet for a query.",
      parameters: {
        type: "object",
        properties: {
          query: {
            type: "string",
            description: "The text query to search for with formatiing instructions (e.g. json, markdown)."
          }
        },
        required: ["query"],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "searchSpotify",
      description: "Search the Spotify for a query.",
      parameters: {
        type: "object",
        properties: {
          query: {
            type: "string",
            description: "The text query to search for."
          },
          type: {
            type: "string",
            description: "The type of Spotify item to search for (options: track, album, artist)."
          }
        },
        required: ["query","type"],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "listPlaylists",
      description: "Get a list of the user's playlists from Spotify.",
      parameters: {
        type: "object",
        properties: {},
        required: [],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "getPlaylistDetails",
      description: "Get detailed information about a specific playlist, including its tracks.",
      parameters: {
        type: "object",
        properties: {
          playlistId: {
            type: "string",
            description: "The ID of the playlist to get details for."
          }
        },
        required: ["playlistId"],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "displayTracks",
      description: "Format and display a track or list of tracks in a user-friendly way.",
      parameters: {
        type: "object",
        properties: {
          tracks: {
            type: "array",
            description: "Array of track objects to display",
            items: {
              type: "object",
              properties: {
                id: { type: "string" },
                name: { type: "string" },
                artists: { 
                  type: "array", 
                  items: { 
                    type: "object",
                    properties: {
                      id: { type: "string" },
                      name: { type: "string" }
                    },
                    required: ["id", "name"],
                    additionalProperties: false
                  } 
                },
                album: { 
                  type: "object",
                  properties: {
                    id: { type: "string" },
                    name: { type: "string" }
                  },
                  required: ["id", "name"],
                  additionalProperties: false
                },
                imageUrl: { type: "string" }
              },
              required: ["id", "name", "artists", "album", "imageUrl"],
              additionalProperties: false
            }
          },
          title: {
            type: "string",
            description: "Optional title to display above the tracks"
          }
        },
        required: ["tracks", "title"],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "displayPlaylist",
      description: "Format and display a playlist with its tracks in a user-friendly way.",
      parameters: {
        type: "object",
        properties: {
          playlist: {
            type: "object",
            description: "Playlist object to display",
            properties: {
              id: { type: "string" },
              name: { type: "string" },
              description: { type: "string" },
              owner: { 
                type: "object",
                properties: {
                  id: { type: "string" },
                  displayName: { type: "string" }
                },
                required: ["id", "displayName"],
                additionalProperties: false
              },
              tracks: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    id: { type: "string" },
                    name: { type: "string" },
                    artists: { 
                      type: "array", 
                      items: { 
                        type: "object",
                        properties: {
                          id: { type: "string" },
                          name: { type: "string" }
                        },
                        required: ["id", "name"],
                        additionalProperties: false
                      } 
                    },
                    album: { 
                      type: "object",
                      properties: {
                        id: { type: "string" },
                        name: { type: "string" }
                      },
                      required: ["id", "name"],
                      additionalProperties: false
                    },
                    imageUrl: { type: "string" }
                  },
                  required: ["id", "name", "artists", "album", "imageUrl"],
                  additionalProperties: false
                }
              },
              imageUrl: { type: "string" },
              totalTracks: { type: "number" }
            },
            required: ["id", "name", "description", "owner", "tracks", "imageUrl", "totalTracks"],
            additionalProperties: false
          }
        },
        required: ["playlist"],
        additionalProperties: false
      },
      strict: true
    }
  }
];
